// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';
import { TGenerateBillingReportReq } from '../types/requests';

export function BillingController() {
  const generateBillingReport = async <T>(data: TGenerateBillingReportReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/report/generate`, data, {
      headers: getAuthHeaders(),
    });
  };

  return { generateBillingReport };
}
